import React, { useEffect, useState } from "react";
import { useHasFetchedConfig, useEndpoints, useEnvironment } from "../../NavProvider";
import MaintenanceMessage from "./MaintenanceMessage";
var Maintenance = function () {
    var _a = useState(""), message = _a[0], setMessage = _a[1];
    var hasConfigFetched = useHasFetchedConfig();
    var environment = useEnvironment();
    var endpoints = useEndpoints();
    useEffect(function () {
        /**
         * TODO:
         * remove config fetch status as dependency of calling bcp endpoint
         * ensure message component is rerendering with updated params when either bcp/config is updated
         */
        if (hasConfigFetched && environment) {
            var endpoint = environment === "development"
                ? endpoints.bcp.dev
                : environment === "staging"
                    ? endpoints.bcp.stg
                    : endpoints.bcp.prod;
            fetch(endpoint)
                .then(function (response) { return response.json(); })
                .then(function (data) {
                var now = Date.now();
                var validMessages = data.response.reduce(function (acc, m) {
                    var preDeploymentStart = new Date(m.preDeploymentStartTime).getTime();
                    var preDeploymentEnd = new Date(m.preDeploymentEndTime).getTime();
                    var deploymentStart = new Date(m.deploymentStartTime).getTime();
                    var deploymentEnd = new Date(m.deploymentEndTime).getTime();
                    if (now >= preDeploymentStart && now < preDeploymentEnd)
                        acc.push(m.preDeploymentAcmMsgEN);
                    else if (now >= deploymentStart && now < deploymentEnd)
                        acc.push(m.deploymentAcmMsgEN);
                    return acc;
                }, []);
                if (validMessages.length)
                    setMessage(validMessages[0]);
            })
                .catch(function (e) {
                console.error("Failed to fetch BCP message", e === null || e === void 0 ? void 0 : e.message);
            });
        }
    }, [hasConfigFetched, environment, endpoints]);
    return (React.createElement("div", { id: "acm-header__maintenance", className: "maintenance" }, message && React.createElement(MaintenanceMessage, { message: message })));
};
export default Maintenance;
